<template>
  <div class="empty-section">
    <v-icon
      class="mb-2 empty-section__icon"
      color="#D4D8E8"
      icon="mdi-light:paperclip"
      size="36"></v-icon>

    <div class="empty-section__title">
      {{ title }}
    </div>

    <div v-if="description" class="empty-section__description">
      {{ description }}
    </div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'EmptySection',
})

defineProps<{
  title: string
  description?: string
}>()
</script>

<style lang="scss" scoped>
.empty-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px 12px;
  text-align: center;
}

.empty-section__title {
  font-size: 15px;
  font-weight: 600;
  color: #6c6c7d;
  margin-bottom: 2px;
  line-height: 1.4;
}

.empty-section__description {
  max-width: 520px;
  font-size: 13px;
  color: #8f90a6;
  line-height: 1.45;
}

.empty-section__icon {
  min-width: 36px;
  min-height: 36px;
  transform: rotate(45deg);
}

.empty-section__icon :deep(svg) {
  min-width: 36px;
  min-height: 36px;
}
</style>
